var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userData)?_c('resource-photo-album',{staticStyle:{"margin-top":"75px"},attrs:{"resource":_vm.selectedResource,"settings":_vm.settings,"user-data":_vm.userData,"is-management-mode":_vm.isManagementMode,"my-app-settings_is-display-activity":_vm.displayActivity,"my-app-settings_is-display-settings":_vm.displaySettings}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }